import { icon as Icon } from './data/icon';

const url = new URL(document.location.href);
const base = url.port === '' ? `${url.protocol}//${url.host}/api` : 'http://localhost:3000/api';

export namespace icon {
    export async function list(book: string | null): Promise<string[]> {
        if (book !== null) {
            const params = new URLSearchParams();
            params.append('book', book);
            const res = await fetch(`${base}/icons?${params.toString()}`);
            return res.json();
        } else {
            const res = await fetch(`${base}/icons`);
            return res.json();
        }
    }
}

export namespace setting {
    export async function set(book: string | null, page: string, icons: Icon[]) {
        const res = await fetch(`${base}/setting`, {
            method: 'post',
            body: JSON.stringify({ book, page, icons }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if (res.status !== 200) {
            const msg = await res.text();
            throw new Error(msg);
        } else {
            return true;
        }
    }
}
